import { useState, useEffect } from 'react';
import RoleService from '../../../../services/role_service';

const Roles = (props) => {
  const [selectedRole, setSelectedRole] = useState('');
  const [roles, setRoles] = useState([]);

  const loadRoles = async () => {
    try {
      props.setLoading(true);
      const rolesData = await RoleService.getAll()
      if (props.logout(rolesData)) return;
      setRoles(
        (rolesData || []).filter(
          (rol) => !props.isEditor || rol?.Name !== 'Super Administrador'
        )
      );
    } catch (e) {
      props.message((e?.message || e), "error");
    } finally {
      props.setLoading(false);
    }
  };

  useEffect(() => {loadRoles()}, []);

  const setRole = async (role) => {
    const lostAccess = await props.losesAccess?.();
    if (lostAccess) return;
    setSelectedRole(role)
  }

  return {
    roles,
    selectedRole,
    setSelectedRole,
    setRole,
    setRoles
  };
};

export default Roles;
